import React, { Component, Fragment } from "react";
import "./sizing.css";
import ProductItemCard from "./ProductItemCard";
import { Link } from "react-router-dom";


export default class ProductSuggestions extends Component {

    state = {
        products: [],
        productsCount: 0
    };

    componentDidMount() {
        this.setState({ products: this.props.products });
        this.setState({ productsCount: this.props.products.length });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
        this.setState({ productsCount: Values.products.length });
    };

    render() {
        return (
            <section className="container">
                <div className="row hrow itemsrow" >
                    {this.state.productsCount > 0 &&
                        <Fragment>
                            <div className="resultheadbox">
                                <h1 className="text-title-body">دستگاه های پیشنهادی برای شما</h1>
                                <span>{this.state.productsCount} دستگاه با مشخصات ورودی اولیه شما مطابقت دارد</span>
                            </div>
                            <div className="col-12 product_present">
                                {this.state.products.map(productItem => (
                                    <ProductItemCard key={productItem.key} id={productItem.id} name={productItem.title} imageAddress={productItem.imageSquareAddress} />
                                ))}
                            </div>
                        </Fragment>
                    }
                    {this.state.productsCount == "0" &&
                        <section className="container">
                            <div className="resultheadbox">
                                <h1 className="text-title-body">دستگاه های پیشنهادی برای شما</h1>
                                <span>هیچ دستگاهی با مشخصات ورودی اولیه شما مطابقت ندارد</span>
                            </div>
                            <div className="row hrow mt-4">
                                <Link className="btn btn-dark" to="/consuling"> درخواست  کارشناس مشاور</Link>
                            </div>
                        </section>
                    }

                </div>
            </section>
        );
    }
}
